<template>
  <div class="html-report-body">
    <iframe
      v-if="fileUrl"
      sandbox="allow-scripts"
      :src="fileUrl"
      style="width: 100%; height: 100%; border: none"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({
  name: 'HtmlReportBody'
})

const props = defineProps({
  panelData: {
    type: Object,
    default: () => ({})
  }
})

const fileUrl = computed(() => props.panelData.fileUrl || '')
</script>

<style lang="scss" scoped>
.html-report-body {
  width: 100%;
  height: 100%;
}
</style>
